const LIVE_CAPTURE_MODAL_META_DATA = {
	modalId: 'live-capture-modal',
	title: 'Live Capture',
	cancelBtnLabel: 'Cancel',
	approvalBtnLabel: 'Register',
	dataURI: '',
};

const IMPORT_FROM_S3_MODAL_META_DATA = {
	modalId: 'import-from-s3-modal',
	title: 'Import From S3',
	s3FolderInvalidFeedback: 'S3 Folder name is required!',
	prefixInvalidFeedback: 'Prefix name is required!',
	validState: undefined,
	cancelBtnLabel: 'Cancel',
	approvalBtnLabel: 'Import',
};

const INTERVAL = 2; //second
const MULTIPLIER = 1000; //multiplier number

const I18N_LANGUAGE = [
	{
		flag: 'https://demos.creative-tim.com/argon-design-system/assets/img/icons/flags/US.png',
		language: 'en',
		title: 'English',
	},
	{
		flag: 'https://demos.creative-tim.com/argon-design-system/assets/img/icons/flags/JP.png',
		language: 'ja',
		title: '日本語',
	},
	{
		flag: 'https://demos.creative-tim.com/argon-design-system/assets/img/icons/flags/VN.png',
		language: 'vn',
		title: 'Tiếng Việt',
	},
];

const GOOD_IMAGE_CLASS = 0;

const CDN_CLOUD_FORMATION = {
	runDetection: process.env.VUE_APP_CDN,
	detectedImage: process.env.VUE_APP_CDN + "720x538/",
	historyImage: process.env.VUE_APP_CDN + "720x543/",
	thumbnailImage: process.env.VUE_APP_CDN + "120x120/"
}

// Image size in Full HD 4:3
const HD_IMAGE_SIZE = {
	WIDTH: 1920,
	HEIGHT: 1440
}

const PIE_CHART_OPTIONS = {
	responsive: true,
	maintainAspectRatio: false,
	plugins:{
		legend: {
			// Position of the legend: 'top', 'bottom', 'left', 'right'
			position: 'bottom',
			labels: {
				usePointStyle: true,
				font:{
					size: 14,
					color: '#4d4d4d'
				}
			}
		},
	}
}

const PIE_CHART_DATA = {
	labels: ['OK Results', 'NG Results'],
	color: ['#2DCE89', '#FF0202']
}

const DATE_TEXT = {
	DAY: 'days',
	HOUR: 'hours',
	
	MINUTE: 'minutes',
	SECOND: 'seconds',
}

export default {
	LIVE_CAPTURE_MODAL_META_DATA,
	IMPORT_FROM_S3_MODAL_META_DATA,
	INTERVAL,
	MULTIPLIER,
	I18N_LANGUAGE,
	GOOD_IMAGE_CLASS,
	HD_IMAGE_SIZE,
	PIE_CHART_OPTIONS,
	PIE_CHART_DATA,
	DATE_TEXT,
	CDN_CLOUD_FORMATION
};
